







import { Component, Mixins } from "vue-property-decorator";
import page from "@/mixins/page";

@Component
class LoanDetail extends Mixins(page) {
  loading = true;

  text = "";

  scheme: any = null;

  get title() {
    const pledgeSymbol = this.scheme?.pledge_asset?.symbol;
    const loanSymbol = this.scheme?.loan_asset?.symbol;
    const symbol =
      (pledgeSymbol && loanSymbol && `${pledgeSymbol}-${loanSymbol}`) || "";
    return this.$t("defi.debit.contact.detail.title", {
      name: symbol
    }) as string;
  }

  get id() {
    return this.$route.params.id;
  }

  mounted() {
    this.requestLoanDetail();
  }

  async requestLoanDetail() {
    this.loading = true;
    try {
      const scheme = await this.$api.defi.getDebitSchemeDetail(this.id);
      this.text = scheme.description;
      this.scheme = scheme;
      this.setProperties();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }
}
export default LoanDetail;
